<ngx-select [allowClear]="false" [items]="items" optionValueField="value" optionTextField="name"
    [disabled]="ngxDisabled" [autoClearSearch]="false" [(ngModel)]="productTypeAll" placeholder="Seleccionar Producto"
    (select)="changeProductAll($event)">

    <ng-template ngx-select-option-not-found let-input>
        "{{input}}" no encontrado
    </ng-template>

</ngx-select>